// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"UploadComponentStyle_inputWrapper__17C3j","fileInput":"UploadComponentStyle_fileInput__1J8dx","buttom":"UploadComponentStyle_buttom__3eH0b"};